import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

class TextArea extends React.Component {
  static propTypes = {
    input: PropTypes.instanceOf(Object)
  }

  render() {
    const { className, input } = this.props;

    return (
      <textarea className={ classNames('form__text-area', className) } onKeyDown={ this._handleOnKeyDown } { ...input } />
    );
  }

  // private

  _handleOnKeyDown = this._handleOnKeyDown.bind(this);

  _handleOnKeyDown(e) {
    const { input: { onChange, value } } = this.props;

    if (e.keyCode === 32) {
      onChange(value + ' ');
    }
  }
}

export default TextArea;



// WEBPACK FOOTER //
// ./app/components/shared/form/_TextArea.jsx